
const SkipLink = ({ description = 'Skip to content', href, contentRef }) => {
  return (
    <a className="skip" href={href} onClick={(e) => {
      e.preventDefault(); // Stop HashRouter
      contentRef.current?.focus();
    }}>
      {description}
    </a>
  );
};

export default SkipLink;